import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Shell } from '@/components/Shell'
import Dashboard from '@/pages/Dashboard'
import Missions from '@/pages/Missions'
import MissionDetail from '@/pages/MissionDetail'
import Players from '@/pages/Players'
import PlayerDetail from '@/pages/PlayerDetail'
import Compare from '@/pages/Compare'
import Weapons from '@/pages/Weapons'
import AdminLayout from '@/pages/admin/AdminLayout'
import AdminLogin from '@/pages/admin/AdminLogin'
import AdminDashboard from '@/pages/admin/AdminDashboard'
import AdminMissions from '@/pages/admin/AdminMissions'
import AdminMissionEditor from '@/pages/admin/AdminMissionEditor'
import AdminUpload from '@/pages/admin/AdminUpload'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

function PublicLayout({ children }: { children: React.ReactNode }) {
  return <Shell>{children}</Shell>
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <PublicLayout>
                <Dashboard />
              </PublicLayout>
            }
          />
          <Route
            path="/missions"
            element={
              <PublicLayout>
                <Missions />
              </PublicLayout>
            }
          />
          <Route
            path="/missions/:id"
            element={
              <PublicLayout>
                <MissionDetail />
              </PublicLayout>
            }
          />
          <Route
            path="/players"
            element={
              <PublicLayout>
                <Players />
              </PublicLayout>
            }
          />
          <Route
            path="/players/:id"
            element={
              <PublicLayout>
                <PlayerDetail />
              </PublicLayout>
            }
          />
          <Route
            path="/compare"
            element={
              <PublicLayout>
                <Compare />
              </PublicLayout>
            }
          />
          <Route
            path="/weapons"
            element={
              <PublicLayout>
                <Weapons />
              </PublicLayout>
            }
          />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="missions" element={<AdminMissions />} />
            <Route path="missions/:id" element={<AdminMissionEditor />} />
            <Route path="upload" element={<AdminUpload />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
